import { Injectable } from '@angular/core';
import { LocalStorageKeys } from '../core/enums/LocalStorageKeys';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  /**
   * Guardar un valor en localStorage con una clave específica.
   */
  set<T>(key: LocalStorageKeys, value: T, notStringify?: boolean): void {
    try {
      if (typeof value === 'undefined') {
        console.error(
          `LocalStorageService: Trying to set undefined value for key "${key}"`
        );
        return;
      }
      const serializedValue = notStringify ? value as string : JSON.stringify(value);
      localStorage.setItem(key, serializedValue);
    } catch (error) {
      console.error(`LocalStorageService: Failed to set key "${key}"`, error);
    }
  }
  get<T>(key: LocalStorageKeys): T | null {
    const item = localStorage.getItem(key);
    if (!item) {
      return null;
    }
    try {
      // Intenta parsear el valor
      return JSON.parse(item) as T;
    } catch (error) {
      // Si falla el parseo, asumimos que es una cadena ya
      return item as unknown as T;
    }
  }
  /**
   * Eliminar un valor desde localStorage.
   */
  remove(key: LocalStorageKeys): void {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error(
        `LocalStorageService: Failed to remove key "${key}"`,
        error
      );
    }
  }

  removeArray(keys: LocalStorageKeys[]): void {
    try {
      keys.forEach((key: LocalStorageKeys) => {
        localStorage.removeItem(key);
      })
    } catch (error) {
      console.error(
        `LocalStorageService: Failed to remove keys`,
        error
      );
    }
  }
  /**
   * Limpiar todos los valores de localStorage.
   */
  clear(): void {
    try {
      localStorage.clear();
    } catch (error) {
      console.error('LocalStorageService: Failed to clear storage', error);
    }
  }
  /**
   * Verifica si existe una clave en localStorage.
   */
  exists(key: LocalStorageKeys): boolean {
    return localStorage.getItem(key) !== null;
  }
}